const dogsProtobufOrder = [
  "DEFAULT",
  "AUSTRALIAN_SHEPHERD",
  "AUSTRALIAN_SHEPHERD_BROWN",
  "BEAGLE",
  "BOERBOEL",
  "BORDER_COLLIE",
  "BORDER_COLLIE_BROWN",
  "BOXER",
  "BULLDOG",
  "BULLTERIER",
  "CHIHUAHUA",
  "CHOW_CHOW",
  "DALMATIAN",
  "DALMATIAN_BROWN",
  "DALMATIAN_REDDISH",
  "DASCHUND",
  "DOBERMAN",
  "GERMAN_SHEPHERD",
  "GOLDEN_RETRIEVER",
  "GOLDEN_RETRIEVER_BROWN",
  "HUSKY",
  "MASTIFF",
  "MASTIFF_WHITE",
  "POODLE",
  "POODLE_SMALL",
  "PUG",
  "ROTTWEILER",
  "SHIBA_INU",
  "CAT",
  "BUNNY",
  "PARROT"
];

const toFileNames = dogsProtobufOrder.map((dogName) => {
  const fileName = dogName.toLowerCase().replaceAll("_", "-");
  return fileName;
});

const lightDogFileNames = toFileNames.flatMap((avatar) => {
  const sleepingAvatar = `light-sleeping-${avatar}.svg`;
  const noisyAvatar = `light-noisy-${avatar}.svg`;
  return [sleepingAvatar, noisyAvatar];
});

const darkDogFileNames = toFileNames.flatMap((avatar) => {
  const sleepingAvatar = `dark-sleeping-${avatar}.svg`;
  const noisyAvatar = `dark-noisy-${avatar}.svg`;
  return [sleepingAvatar, noisyAvatar];
});

const dogFileNames = [...darkDogFileNames, ...lightDogFileNames];

export { lightDogFileNames, darkDogFileNames, dogFileNames };
